<template>
  <div id="app">
    <MobileHeader v-if="!isAdminPage" />
    <TopBanner v-if="!isAdminPage" @open-register="openFloatingRegister" />
    <main class="main-content" :class="{ 'with-header': !isAdminPage }">
      <router-view />
    </main>
    <FooterSection v-if="!isAdminPage" />
    <MobileFloatingBar v-if="!isAdminPage" ref="floatingBar" />
  </div>
</template>

<script>
import TopBanner from '@/components/TopBanner.vue'
import MobileFloatingBar from '@/components/MobileFloatingBar.vue'
import MobileHeader from '@/components/MobileHeader.vue'
import FooterSection from '@/components/FooterSection.vue'

export default {
  name: 'App',
  components: { TopBanner, MobileFloatingBar, MobileHeader, FooterSection },
  computed: {
    isAdminPage() {
      return this.$route.path.startsWith('/admin')
    }
  },
  methods: {
    openFloatingRegister() {
      if (this.$refs.floatingBar) {
        this.$refs.floatingBar.openRegister()
      }
    }
  }
}
</script>

<style>
@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable-dynamic-subset.min.css');
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Noto+Serif+KR:wght@400;500;600;700;900&display=swap');
@import url('https://cdn.jsdelivr.net/gh/fonts-archive/Paperlogy/subsets/Paperlogy-dynamic-subset.css');

:root {
  --font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  --font-family2: 'Roboto', sans-serif;
  --font-family4: 'Noto Serif KR', serif;
  --font-paperlogy: 'Paperlogy', sans-serif;

  /* 푸르지오 브랜드 컬러 - 브리티시 그린 + 골드/크림 액센트 */
  --primary: #1B4332;       /* 브리티시 그린 (메인) */
  --primary-light: #2D6A4F; /* 밝은 그린 */
  --primary-dark: #0D2A1E;  /* 짙은 그린 */
  --sub-color: #f0efe2;     /* 크림 (배경 액센트) */
  --accent-gold: #c9a14a;   /* 골드 (프리미엄 포인트) */
  --text-color: #666666;
  --white: #ffffff;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: var(--font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-color);
}

html, body {
  overflow-x: hidden;
  width: 100%;
}

.main-content.with-header {
  padding-top: 60px;
}

body.has-top-banner .main-content.with-header {
  padding-top: 120px;
}

#app {
  overflow-x: hidden;
  width: 100%;
}
</style>
